import React, { Component } from "react";
import { Card, Row, Col, Tooltip } from "antd";
import { Fragment } from "react";
import "../../../ListUser/AuthUsers/Incidents.css";
import moment from "moment";

export default class ClaimsDetail extends Component {
  // moopInformation
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const moopInformation = this.props.moopInformation;
    const memberInformation = this.props.memberInformation;
    const paymentInformtaions = this.props.paymentInformtaions;
    return (
      <Fragment>
        {moopInformation && moopInformation.length > 0 ? (
          <Card className="pr-2 pb-2 mb-2 pl-3">
            <div className="m-2 pt-1 details-header-sub">01. Moop History</div>
            <div className="mx-1">
              <div className="">
                <div className="GrayLighter">
                  <Row className="mx-2 mt-3 pb-3">
                    <Col span={4} className="grey-text pr-2">
                      {" "}
                      Moop Year
                    </Col>
                    <Col span={4} className="grey-text pr-2">
                      {" "}
                      Copay
                    </Col>
                    <Col span={4} className="grey-text pr-2">
                      {" "}
                      Coinsurance
                    </Col>
                    <Col span={4} className="grey-text pr-2">
                      Deductible
                    </Col>
                    <Col span={4} className="grey-text pr-2">
                      Moop Total
                    </Col>
                    <Col span={4} className="grey-text pr-2">
                      Max Moop Limit
                    </Col>
                  </Row>
                </div>
              </div>
              <div>
                <div style={{ color: "#646464", fontWeight: "lighter" }}>
                  <div>
                    <Row>
                      <Col className="pointer" span={24} xs={24}>
                        {moopInformation &&
                          moopInformation.map((item) => (
                            <>
                              <div
                                className={`claims-card-background pb-2 RowHelper`}
                              >
                                <Row className="px-2 pb-2 blockItem pt-2">
                                  <Col span={4} className={`pr-0`}>
                                    <div className="ellipsisText tt-uc">
                                      <Tooltip
                                        title={item.moopYear}
                                        placement="topLeft"
                                        align="left"  
                                      >
                                        {item.moopYear ? item.moopYear : "---"}
                                      </Tooltip>
                                    </div>
                                  </Col>
                                  <Col span={4} className={`pr-2`}>
                                    <div className="ellipsisText tt-uc">
                                      <Tooltip
                                        title={`$ ${item.coPay}`}
                                        placement="topLeft"
                                        align="left"
                                      >
                                        {item.coPay ? `$ ${item.coPay}` : "$ 0"}
                                      </Tooltip>
                                    </div>
                                  </Col>
                                  <Col span={4} className={`pr-2`}>
                                    <div className="ellipsisText tt-uc">
                                      <Tooltip
                                        title={`$ ${item.coInsurance}`}
                                        placement="topLeft"
                                        align="left"
                                      >
                                        {item.coInsurance
                                          ? `$ ${item.coInsurance}`
                                          : "$ 0"}
                                      </Tooltip>
                                    </div>
                                  </Col>
                                  <Col span={4} className={`pr-2`}>
                                    <div className="ellipsisText tt-uc">
                                      <Tooltip
                                        title={`$ ${item.deductable}`}
                                        placement="topLeft"
                                        align="left"
                                      >
                                        {item.deductable
                                          ? `$ ${item.deductable}`
                                          : "$ 0"}
                                      </Tooltip>
                                    </div>
                                  </Col>
                                  <Col span={4} className={`pr-2`}>
                                    <div className="ellipsisText tt-uc">
                                      <Tooltip
                                        title={`$ ${item.totalMemberResponsiblity}`}
                                        placement="topLeft"
                                        align="left"
                                      >
                                        {item.totalMemberResponsiblity
                                          ? `$ ${item.totalMemberResponsiblity}`
                                           : "$ 0"}
                                      </Tooltip>
                                    </div>
                                  </Col>
                                  <Col span={4} className={`pr-2`}>
                                    <div className="ellipsisText tt-uc">
                                      <Tooltip
                                        title={`$ ${item.maxMoopLimit}`}
                                        placement="topLeft"
                                        align="left"
                                      >
                                        {item.maxMoopLimit
                                          ? `$ ${item.maxMoopLimit}`
                                           : "$ 0"}
                                      </Tooltip>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </>
                          ))}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        ) : (
          <div className="mt-5 mb-5 h6 d-flex justify-content-center">
            <span>No data found</span>
          </div>
        )}
      </Fragment>
    );
  }
}
